<template>
	<div class="component">
		<p class="label">
			{{ question.name }}
			<span v-if="question.mustAnswer" class="required"> * </span>
			<van-icon v-if="question.remark" @click="show = true" name="question-o" />
		</p>
		<van-field :rules="rule" class="van_field" style="background:#ffffff">
			<template #input>
				<van-checkbox-group
					:disabled="disabled"
					:value="val"
					class="radio-group"
					:class="{ inline: question.layoutType === 2 }"
				>
					<div class="radio-item" v-for="(option,optionIndex) in qus.optionList" :key="option.id">
						<van-checkbox
							class="checkbox-card"
							@click="handleChange(option)"
							:name="option.name"
							shape="square"
						>
							{{ option.name }}
						</van-checkbox>
						<template v-if="option.ext&&val.indexOf(option.name)>-1">
							<div v-for="(item,index) in option.ext" :key="index">
								<div class="checkbox_or_radio_input_row">
									<van-field
										v-if="item.type === 'input'"
										v-model="item.value"
										:maxlength="item.maxlength"
										:disabled="disabled"
										:rules="val.indexOf(option.name)>-1&&item.mustAnswer ? Rules.require : []"
										placeholder="请输入"
										:error-message-align="item.textAlign||'right'"
										:input-align="item.textAlign||'right'"
										:label="item.label"
										class="checkbox_input"
									>
										<template #extra
											><span class="suffixName">{{item.suffixName}}</span></template
										>
									</van-field>
									<van-field
										v-if="item.type === 'picker'"
										readonly
										v-model="item.value"
										:label="item.label"
										placeholder="请选择"
										:rules="val.indexOf(option.name)>-1&&item.mustAnswer ? Rules.require : []"
										:error-message-align="item.textAlign||'right'"
										:input-align="item.textAlign||'right'"
										class="checkbox_input"
										@click="showPicker(index,optionIndex,item)"
									>
										<template #extra>
											<span class="suffixName">{{item.suffixName}}</span>
										</template>
									</van-field>
									<div v-if="item.type === 'radio'" class="secondary_checkbox_radio">
										<div class="secondary_checkbox_radio_title" v-if="item.title ">
											{{ item.title }}
										</div>
										<van-field class="radio-item-checkbox" :rules="Rules.require">
											<template #input>
												<van-radio-group
													:disabled="disabled"
													v-model="item.value"
													:class="{secondary_inline:item.layoutType === 2}"
												>
													<div
														class="item-group"
														v-for="sonRadio in item.options"
														:key="sonRadio.name"
													>
														<van-radio :name="sonRadio.name">{{sonRadio.name}}</van-radio>
													</div>
												</van-radio-group>
											</template>
										</van-field>
									</div>
									<van-field
										v-if="item.type === 'date'"
										v-model="item.value"
										:disabled="disabled"
										:rules="val.indexOf(option.name)>-1&&item.mustAnswer ? Rules.require : []"
										:placeholder="item.placeholder||'请选择时间'"
										:error-message-align="item.textAlign||'right'"
										:input-align="item.textAlign||'right'"
										readonly
										right-icon="arrow"
										:label="item.label"
										class="checkbox_input"
										@click-input="showPopup(index,optionIndex)"
									></van-field>
									<div v-if="item.type === 'checkbox'" class="secondary_checkbox_radio">
										<div class="secondary_checkbox_radio_title" v-if="item.title ">
											{{ item.title }}
										</div>
										<van-field class="radio-item-checkbox" :rules="Rules.require">
											<template #input>
												<van-checkbox-group
													:disabled="disabled"
													:value="item.value"
													:class="{ inline: question.layoutType === 2 }"
												>
													<div
														class="item-group"
														v-for="( sonRadio , sonIndex) in item.options"
														:key="sonRadio.name"
													>
														<van-checkbox
															@click="handleChangeSon(sonRadio,item,sonIndex)"
															:name="sonRadio.name"
															shape="square"
														>
															{{ sonRadio.name }}
														</van-checkbox>
													</div>
												</van-checkbox-group>
											</template>
										</van-field>
									</div>
								</div>
								<!-- 上传图片 -->
								<!-- <div v-if="item.type === 'img'">
								
									<van-field>
										<template #input>
											<upload
												v-model="option.ext.fileUrl"
												:rules="val.indexOf(option.name)>-1&&option.ext.imageMustAnswer ? Rules.require : []"
												:disabled="disabled"
												:verifyMax="option.ext.maxlength"
												@success="change"
												@delete="change"
											/>
										</template>
									</van-field>
								</div>
								<div v-if="item.type === 'checkbox'">
									<van-field class="radio-item-checkbox" :rules="Rules.require">
										<template #input>
											<van-radio-group
												:disabled="disabled"
												v-model="option.ext.checkBoxValue"
											>
												<div
													class="item-group"
													v-for="item in option.ext.options"
													:key="item.name"
												>
													<van-radio :name="item.name">{{item.name}}</van-radio>
												</div>
											</van-radio-group>
										</template>
									</van-field>
								</div> -->
							</div>
						</template>
					</div>
				</van-checkbox-group>
			</template>
		</van-field>
		<van-popup v-model="showDateTimeCard" position="bottom">
			<van-datetime-picker
				v-model="currentDate"
				:type="datetimeType"
				title="请选择"
				:min-date="minDate"
				:max-date="maxDate"
				@cancel="showDateTimeCard = false"
				@confirm="onConfirm"
			/>
		</van-popup>
		<van-popup v-model="showPickerCard" position="bottom">
			<van-picker
				title="请选择"
				show-toolbar
				:columns="columns"
				@confirm="onConfirmPicker"
				@cancel="showPickerCard = false"
			/>
		</van-popup>
		<g-question-description v-model="show" :list="list" />
	</div>
</template>

<script>
import Rules from '@/utils/reg';
import GQuestionDescription from "./GQuestionDescription.vue";
export default {
    name: "GCheckboxGroup",
    components: { GQuestionDescription },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        question: {
            type: Object,
            default: () => { }
        },
        rule: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        list () {
            return this.question.remark.split('\n')
        },
        val: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val);
                this.$emit('change')
            }
        },
    },
    data () {
        return {
            datetimeType: "date",
            show: false,
            showDateTimeCard: false,
            showPickerCard: false,
            pickerVal: '',
            currentDate: '',
            columns: [],
            qus: {},
            index: '',
            selectOptionIndex: '',
            minDate: new Date(1970, 0, 1),
            maxDate: new Date(2025, 10, 1),
            Rules
        }
    },
    created () {
        this.formatData();
    },
    methods: {
        handleChange (item) {
            if (this.disabled) {
                return
            }
            let clearArr = this.qus.optionList.filter(v => v.setting && v.setting.type == 'clear').map(v => v.name)
            let type = this.val.indexOf(item.name)
            if (type == -1) {
                if (item.setting && item.setting.type === 'clear') {
                    this.val = [item.name]
                } else {
                    let arr = JSON.parse(JSON.stringify(this.val))
                    arr = arr.filter(v => clearArr.indexOf(v) == -1)
                    arr.push(item.name)
                    this.val = arr
                }
            } else {
                this.val.splice(type, 1)
            }
        },
        handleChangeSon (item, question, index) {
            if (item.setting && item.setting.type === 'clear') {
                question.value = [item.name]
            } else {
                console.log(question)
                let clearArr = question.options.filter(v => v.setting && v.setting.type == 'clear').map(v => v.name)
                let arr = JSON.parse(JSON.stringify(question.value))
                arr = arr ? arr.filter(v => clearArr.indexOf(v) == -1) : []
                console.log(question, item.name, arr)
                arr.push(item.name)
                question.value = arr
            }
            console.log(item, question, index)
        },
        change () {
            this.$emit('change');
        },
        formatData () {
            this.qus = this.question;
            this.qus.optionList.forEach(option => {
                try {
                    if (typeof option.ext === 'string') {
                        option.ext = JSON.parse(option.ext)
                    }
                } catch (e) {
                    console.log(e)
                }
            });
        },
        showPopup (index, optionIndex) {
            this.showDateTimeCard = true
            this.selectIndex = index
            this.selectOptionIndex = optionIndex
            this.currentDate = new Date()
        },
        //时间选择器 确认
        onConfirm (val) {
            this.showDateTimeCard = false
            this.qus.optionList[this.selectOptionIndex].ext[this.selectIndex].value = this.$moment(val).format('YYYY-MM-DD')
        },
        showPicker (index, optionIndex, item) {
            this.showPickerCard = true
            this.selectIndex = index
            this.selectOptionIndex = optionIndex
            this.pickerVal = item.val || ''
            this.columns = item.columns
        },
        onConfirmPicker (val) {
            this.showPickerCard = false
            this.qus.optionList[this.selectOptionIndex].ext[this.selectIndex].value = val
        }
    }
}
</script>
<style lang="less" scoped>
@import './base.less';
.component {
	.van_field {
		padding: 20px 0;
	}
	.radio-group {
		width: 100%;
		border-radius: 8px;
		overflow: hidden;
		font-size: 32px;
		&.inline {
			// display: flex;
			// flex-wrap: wrap;
			width: calc(100% + 14px);
			.radio-item {
				min-width: 33.3333%;
				margin-right: 14px;
				float: left;
				border-bottom: none;
			}
		}
		.checkbox-card {
			background-color: #ffffff;
			padding: 32px 32px;
		}
		.radio-item-checkbox {
			background-color: #fafafa;
			padding: 0 56px;
			.van-radio-group {
				border-bottom: 1px solid #eeeeee;
				&:last-child {
					border-bottom: none;
				}
			}
		}
		.radio-item-input {
			padding: 32px 32px;
			background-color: #ffffff;
		}
		.radio-item {
			border-bottom: 1px solid #f5f5f5;
			&:last-child {
				border-bottom: none;
			}
		}
		.radio-item-ext {
			padding: 0 52px;
			background-color: #fafbfc;
		}
		.item-group {
			padding: 31px 0;
		}
	}

	.checkbox_input {
		background-color: #f9f9f9;
		border-radius: 16px;
		font-size: 30px;
		color: #1f2329;
	}
	.suffixName {
		margin-left: 14px;
	}
}
</style>
